import React from "react";
import {cx} from "../../lib/ClassSet";
import CommandWindow from "./CommandWindow";
import Window from "./Window";
import {buildWindowContent} from "./WindowFactory";
import "./WindowContainer.css";

// const WINDOW_ZINDEX_START = 0;
const MODAL_ZINDEX_START = 500;

const WindowContainer = (props) => {

  let modalBlockerClasses = cx({
    "modalBlocker": true,
    "s-active": props.modalActive,
    "s-inactive": !props.modalActive 
  })

  // Do we have any windows?
  let windowElements = null;
  let nrWindows = props.windows.size;
  if (nrWindows > 0) {
    windowElements = props.windows.map((win, index) => {
      return React.createElement(
        Window,
        {
          key: win.get("id"),
          windowId: win.get("id"),
          title: win.get("title"),
          index: index,
          focused: index === (nrWindows-1)
        },
        buildWindowContent(win.get("kind"), win.get("id"), win.get("payload"))
        );
    })
  }

  // Do we have any modals?
  let modalElements = null;
  if (props.modalActive) {
    // Only the last modal can be active.
    const lastModalIndex = props.modals.size - 1;
    modalElements = props.modals.map((modal, index) => {
      return React.createElement(
        CommandWindow, 
        {
          key: modal.get("id"),
          title: modal.get("title"),
          index: MODAL_ZINDEX_START + index,
          active: index === lastModalIndex,
          modal: true,
          headless: modal.getIn(["options", "headless"], false),
          width: modal.getIn(["options", "width"], null),
          cancelType: modal.getIn(["options", "cancelType"], null),
        },
        buildWindowContent(modal.get("kind"), modal.get("id"), modal.get("payload"))
        );
    })
  }

  return (
    <div className="WindowContainer">
      {windowElements}
      <div className={modalBlockerClasses} />
      {modalElements}
    </div>
  )

}

export default WindowContainer;